import mdAxios from 'core/common/config/axios-config';

import {IDomainObject} from "core/form/formUtils";
import {MdFieldDto, MdEntityDto} from "core/metamodel/metaDomain";
import {observable} from "mobx";

class MdConfigService {

  @observable entityObject: MdEntityDto;
  @observable fieldObject: MdFieldDto;

  readEntityDto(entityName: string): Promise<MdEntityDto> {
    return mdAxios.get('/core/meta/entity/' + entityName)
      .then((response) => new MdEntityDto(response.data));
  }

  saveEntityDto(entityObject: MdEntityDto): Promise<IDomainObject> {
    return mdAxios.post('/core/meta/entity', entityObject, {showPrettyError: true})
      .then((response) => response.data);
  }

  readFieldDto(fieldKey: string): Promise<MdFieldDto> {
    return mdAxios.get('/core/meta/field/' + fieldKey)
        .then((response) => new MdFieldDto(response.data));
  }

  saveFieldDto(fieldObject: MdFieldDto): Promise<IDomainObject> {
    return mdAxios.post('/core/meta/field', fieldObject, {showPrettyError: true})
      .then((response) => response.data);
  }

}

const mdConfigService = new MdConfigService();
export default mdConfigService;



// WEBPACK FOOTER //
// ./src/core/metamodel/mdConfigService.ts